import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { convertDate } from '../../../utility/dates';

import { providerSurgeIncentiveEditForm } from '../actions';
import ProviderSurgeIncentiveEditForm from './provider-surge-incentive-edit-form';
import SurgeIncentive from '../interfaces/surge-incentive-interface';

export class ProviderSurgeIncentiveEditFormContainer extends Component {
  componentDidMount() {
    const {
      surgeIncentive: {
        provider_incentive_cost_id: id,
        start_date: startDate,
        end_date: endDate,
        amount
      },
      surgeIncentiveStatus: status,
      initialize
    } = this.props;

    initialize({
      id,
      'start-date': convertDate(startDate),
      'end-date': convertDate(endDate),
      amount,
      status
    });
  }

  render() {
    const {
      formValues,
      formErrors,
      submit,
      changeField,
      surgeIncentiveStatus,
      submitting
    } = this.props;

    return (
      <ProviderSurgeIncentiveEditForm
        formValues={formValues}
        formErrors={formErrors}
        submit={submit}
        changeField={changeField}
        surgeIncentiveStatus={surgeIncentiveStatus}
        submitting={submitting}
      />
    );
  }
}

const mapStateToProps = state => ({
  formValues: state.providerSurgeIncentive.editForm.formValues,
  formErrors: state.providerSurgeIncentive.editForm.formErrors,
  shouldCloseModal: state.providerSurgeIncentive.editRequest.isSuccess,
  submitting: state.providerSurgeIncentive.editRequest.isLoading
});

const mapDispatchToProps = {
  changeField: providerSurgeIncentiveEditForm.changeField,
  submit: providerSurgeIncentiveEditForm.submit,
  initialize: providerSurgeIncentiveEditForm.initialize
};

ProviderSurgeIncentiveEditFormContainer.propTypes = {
  formValues: PropTypes.object.isRequired,
  formErrors: PropTypes.array.isRequired,
  changeField: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  initialize: PropTypes.func.isRequired,
  surgeIncentive: SurgeIncentive,
  surgeIncentiveStatus: PropTypes.string.isRequired,
  submitting: PropTypes.bool.isRequired
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProviderSurgeIncentiveEditFormContainer);
